import { useMemo } from 'react'
import { orderBy } from 'lodash'

import { FormAutocomplete, FormAutocompleteProps } from '@collaborate-health/forms'
import { LocationResponse } from '@tabeeb/contracts/microservices/swagger-certificate-service'

export interface LocationsFieldProps {
  name: string
  disabled?: boolean
  loading?: boolean
  locations: LocationResponse[]
}

const LocationsField: React.FC<LocationsFieldProps> = ({ name, disabled = false, locations, loading = false }) => {
  const options = useMemo<FormAutocompleteProps<number>['options']>(
    () =>
      orderBy(locations, (l) => l.CountryName).map((location) => ({
        value: location.Id,
        name: location.Name,
        group: location.CountryName,
      })),
    [locations]
  )

  return (
    <FormAutocomplete
      name={name}
      multiple
      disabled={disabled}
      label='Locations'
      placeholder='Search locations...'
      loading={loading}
      options={options}
      groupBy={(option) => option.group!}
      limitTags={5}
      disableCloseOnSelect
    />
  )
}

export default LocationsField

